module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Light.ab391a61.ttf";